import React from "react";
import {Route} from "react-router-dom";
import EditContract from "../../pages/contractOTC/editContract";
import {EDIT_CONTRACT_ROUTE} from "../../utils/constants/RoutesConstants";

const ContractOTCRoutes = () => {
    return (
        <React.Fragment>
            <Route path={EDIT_CONTRACT_ROUTE} component={EditContract}/>
        </React.Fragment>
    );
};

export default ContractOTCRoutes;